/**
 * KAN-808: цвет тира ранга — подложка под мини-крест в составе (эпик KAN-804).
 *
 * Крест сам по себе мелкий и в тёмной теме сливается с карточкой. Макет решает это
 * подложкой в цвет тира с прозрачностью 15%: ранг читается боковым зрением, но не
 * спорит с ником, который в строке главный.
 *
 * Значения — из макета. Это не токены темы: цвета тиров задаёт Riot, они одинаковы
 * в светлой и тёмной и от нашей палитры не зависят.
 */

const TIER_COLOR: Record<string, string> = {
  CHALLENGER: "#f0abfc",
  GRANDMASTER: "#fb7185",
  MASTER: "#a855f7",
  DIAMOND: "#60a5fa",
  EMERALD: "#34d399",
  PLATINUM: "#22d3ee",
  GOLD: "#f5b942",
  SILVER: "#94a3b8",
  BRONZE: "#b07a4a",
  IRON: "#7a6a63",
};

/**
 * Подложка под крест ранга. null — тир неизвестен: тогда подложки нет вовсе, а не
 * серая заглушка, которая выглядит как ещё один тир.
 */
export function rankTierBackground(rank?: string | null): string | null {
  if (!rank?.trim()) return null;

  const upper = rank.trim().toUpperCase();
  const key = Object.keys(TIER_COLOR).find((tier) => upper.startsWith(tier));

  return key ? `color-mix(in srgb, ${TIER_COLOR[key]} 15%, transparent)` : null;
}
